import { EmployerSignin, EmployerSignup, HomePage } from "../../pages";
import { ForgotPassword, SignIn, SignUp } from "../../pages/(auth)";
import MainSignup from "../../pages/MainSignup";
// CLEANER IMPORTS: Import all employer components from index
import { 
    Dashboard, 
    PositionIndex, 
    AddPosition, 
    EditPosition,
    ViewPositions, 
    ManageApplications, 
    ManageInterns,
    ManagePositions,
    CompanyProfileManagement,
    EmployerAnnouncements,
    EmployerSettings,
    ApplicationSubmitted,
    DocumentVerification
} from "../pages";
import ELayout from "./Layout";
import { FaTachometerAlt, FaClipboardList, FaUserGraduate, FaClipboardCheck, FaUsers, FaBullhorn, FaBuilding } from 'react-icons/fa';

export const employer_nav = [
   
    // employer navs
    {
        path: "/employer/", 
        name: "Dashboard", 
        element: <ELayout><Dashboard/></ELayout>, 
        icon: <FaTachometerAlt className="h-4 w-4" />, 
        isMenu: true, 
        isPrivate: true
    },
    {
        path: "/employer/manage-interns", 
        name: "Manage Interns", 
        element: <ELayout><ManageInterns/></ELayout>, 
        icon: <FaUsers className="h-4 w-4" />, 
        isMenu: true, 
        isPrivate: true
    },    
    {
        path: "/employer/positions", 
        name: "Manage Positions", 
        element: <ELayout><ManagePositions/></ELayout>,
        icon: <FaUserGraduate className="h-4 w-4"/>, 
        isMenu: true, 
        isPrivate: true
    },
    {
        path:'/employer/positions/view', 
        name:"View Positions", 
        element: <ELayout><ViewPositions /></ELayout>,
        isMenu: false, 
        isPrivate: true
    },
    {
        path:'/employer/positions/add', 
        name:"Add Position", 
        element: <ELayout><AddPosition /></ELayout>,
        isMenu: false, 
        isPrivate: true
    },
    {
        path:'/employer/positions/edit/:id', 
        name:"Edit Position", 
        element: <ELayout><EditPosition /></ELayout>,
        isMenu: false, 
        isPrivate: true
    },
    {
        path: "/employer/applications", 
        name: "Manage Applications", 
        element: <ELayout><ManageApplications/></ELayout>, 
        icon: <FaClipboardCheck className="h-4 w-4" />, 
        isMenu: true, 
        isPrivate: true
    },
    {
        path: "/employer/announcements", 
        name: "Announcements", 
        element: <ELayout><EmployerAnnouncements/></ELayout>,
        icon: <FaBullhorn className="h-4 w-4" />, 
        isMenu: true, 
        isPrivate: true
    },
    {
        path: "/employer/company-profile", 
        name: "Company Profile", 
        element: <ELayout><CompanyProfileManagement/></ELayout>,
        icon: <FaBuilding className="h-4 w-4" />, 
        isMenu: true, 
        isPrivate: true
    },
    {
        path: "/employer/settings", 
        name: "Settings", 
        element: <ELayout><EmployerSettings/></ELayout>, 
        isMenu: false, 
        isPrivate: true
    },

    // Auth routes
    {
        path: "/employer/login", 
        name: "EmployerLogin", 
        element: <EmployerSignin/>, 
        isMenu: false, 
        isPrivate: false, 
        isEmployer: true
    },
    {
        path: "/employer/register", 
        name: "EmployerRegister", 
        element: <EmployerSignup/>, 
        isMenu: false, 
        isPrivate: false, 
        isEmployer: true
    },
    {
        path: "/employer/application-submitted", 
        element: <ApplicationSubmitted/>,
        isMenu: false, 
        isPrivate: false, 
        isEmployer: true
    },
    {
        path: "/employer/document-verification", 
        element: <DocumentVerification/>,
        isMenu: false, 
        isPrivate: false, 
        isEmployer: true
    },
    {
        path: "/main-signup", 
        name: "MainSignup", 
        element: <MainSignup/>, 
        isMenu: false, 
        isPrivate: false
    },
    {   path: "/forgot-password", 
        name: "forgot-password", 
        element: <ForgotPassword/>, 
        isMenu:false, 
        isPrivate:false
    },
];